import { Injectable, inject } from '@angular/core';

import type {
  ReportDashboardMetricOptions,
  ReportDashboardComponent,
  ReportsComponentTileFilterBreadcrumbSync,
  ReportsFilterBreadcrumb,
  ReportsBreadcrumbsDirector,
  BreadcrumbsBuilders,
  BreadcrumbsData,
} from '@core/reports-types';

import { AppliedFiltersBreadcrumbsService } from './applied-filters-breadcrumbs.service';
import { DateBreadcrumbsService } from './date-breadcrumbs.service';
import { DatePointsBreadcrumbsService } from './date-points-breadcrumbs.service';

@Injectable()
export class ReportsBreadcrumbsService implements ReportsBreadcrumbsDirector {
  private readonly dateFilters = inject(DateBreadcrumbsService);
  private readonly appliedFilters = inject(AppliedFiltersBreadcrumbsService);
  private readonly datePointFilters = inject(DatePointsBreadcrumbsService);

  private readonly BREADCRUMBS: BreadcrumbsBuilders = [
    this.dateFilters,
    this.datePointFilters,
    this.appliedFilters,
  ];

  public getBreadcrumbs(
    data: BreadcrumbsData,
    metric: ReportDashboardMetricOptions,
    componentSavedFilters: Pick<ReportDashboardComponent, 'filters' | 'dateFilter' | 'settings'>,
  ): ReportsFilterBreadcrumb[] {
    const params = { data, metric, componentSavedFilters };
    return this.BREADCRUMBS.map(service => service.getBreadcrumbs(params)).flat();
  }

  public getBreadcrumbsSync(
    data: BreadcrumbsData,
    metric: ReportDashboardMetricOptions,
    componentSavedFilters: Pick<ReportDashboardComponent, 'filters' | 'dateFilter' | 'settings'>,
  ): ReportsComponentTileFilterBreadcrumbSync[] {
    const params = { data, metric, componentSavedFilters };
    return this.BREADCRUMBS.map(service => service.getBreadcrumbsSync(params)).flat();
  }
}
